<template>
  <div class="pickers">
    <div class="datePicker input-field mo-margins" v-if="pickerType === 'date'">
        <input 
        :disabled="dataDisabled"
        :value="defaultDate"
        id="datePickerDate"
        name="datePickerDate"
        type="text" class="datepicker"  ref="date" >
        <label v-if="!hideLabels" for="datePickerDate"><slot>Delivery Date</slot></label>
    </div>
    <input type="date" name="datePicker" class="browser-default" v-model="dateValue" id="datePicker">
  </div>
</template>
<script>
import M from 'materialize-css'
import moment from 'moment'
export default {
name:'datePicker',
props:{
  pickerType:{
    type:String,
    default:'date'
  },
  yearRange: {
    type: [Number, Array],
    default () {
      let date = moment(new Date()).format('yyyy')
      return [1999,  parseInt(date)]
    }
  },
  dateFormat:{
    type:String, 
    default:'mm/dd/yyyy'
    },
  maxDate:{
    type:Date,
    default(){
      return new Date
    }
  },
  dataDisabled:{
    type:Boolean,
    default:true,
  },
  dataContainer:{
    type:String,
  },
  defaultDate:{
    type:[String, Date],
    default(){
      return  moment(new Date).format('MMM DD, YYYY')
    }
  },
  hideLabels:{
    type:Boolean,
    default:false,
  }
},
computed: {
  dateValue:{
    get () {
      return new Date(this.defaultDate)
    },
    set (e) {
   
      this.$emit('date',{
            date:moment(e).format('MM/DD/YYYY')
          })
    }
  }
},
watch:{
  defaultDate:function(nV){
     if(nV) {
       window.console.log(nV)
      //this.pickers.date.instance.setDate(new Date(nV))
      //this.pickers.date.instance.el.value = moment(new Date(nV)).format('MMM DD, YYYY')
    } 
  }
},
data(){
  let vm = this
  return {
    pickers:{
    date:{
      instance:null,
      calendarEl:'',
      dates:'',
      options:{
        //format:vm.dateFormat,
        //minDate:new Date(),
        yearRange: this.yearRange,
       // defaultDate:vm.defaultDate,
        maxDate: this.maxDate,
        setDefaultDate:true,
        container:document.querySelector("#pickerContainer"),
        onOpen:()=>{
          //document.querySelector('body').classList.add('pickingDate')
        },
        onSelect:(e)=>{
          vm.pickers.date.dates = e
          vm.$emit('date',{
            date:moment(new Date(vm.pickers.date.dates)).format('MMM DD, YYYY')
          })
        },
        onClose:()=>{
          // document.querySelector('body').classList.remove('pickingDate')
          
        }
      }
    }
     },
  }
},
mounted(){
  //this.$_initPickers();
},
destroyed(){
  try{
   // document.querySelector('#pickerContainerElement').innerHTML = ''
   this.pickerType === 'date' 
   ? this.pickers.date.instance.destroy()
   : false
  }catch(e){
    return e
  }
},
methods:{
  $_initPickers(){
    let datePicker = this.$refs.date
    if(this.pickerType === 'date'){
      this.pickers.date.instance = M.Datepicker.init(datePicker, this.pickers.date.options)
     // this.pickers.date.instance.set(this.defaultDate)
    }
  }
}
}
</script>

<style scoped lang="scss">

</style>
